import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../decorators'
import {
  getProductCategoryListData,
  getProductCategoryOverviewData,
} from './mockData'
import type {
  IProductCategory,
  IProductCategoryOverview,
} from '~/types/product/models'

export const apiEntityPath = '/api/productcategories'

interface GetProductCategoriesResponse {
  data: IProductCategory[]
}

async function getList(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  console.log(`Returning productCategory list`)
  const responseBody: GetProductCategoriesResponse = {
    data: await getProductCategoryListData(),
  }
  return res(ctx.status(200), ctx.json(responseBody))
}

interface GetProductCategoryOverviewResponse {
  data: IProductCategoryOverview
}

async function getOverviewById(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const { id } = req.params
  if (typeof id !== 'string') {
    const responseBody = {
      statusCode: 500,
      message: 'Passed ID is not a string',
    }
    return res(ctx.status(500), ctx.json(responseBody))
  }
  const obj = await getProductCategoryOverviewData(id)
  if (obj) {
    console.log(`Returning overview for productCategory "${id}"`)
    const responseBody: GetProductCategoryOverviewResponse = {
      data: obj,
    }
    return res(ctx.status(200), ctx.json(responseBody))
  } else {
    const responseBody = { statusCode: 404, message: 'Resource not found.' }
    return res(ctx.status(404), ctx.json(responseBody))
  }
}

// post

const postProductCategory = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(req, res, ctx, getProductCategoryListData)
}

const patchProductCategory = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getProductCategoryListData)
}

const deleteProductCategory = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(req, res, ctx, getProductCategoryListData)
}

export const handlers = [
  {
    method: 'get',
    path: apiEntityPath,
    handler: getList,
  },
  {
    method: 'get',
    path: '/api/productcategories/:id/overview',
    handler: getOverviewById,
  },
  {
    method: 'post',
    path: apiEntityPath,
    handler: postProductCategory,
  },
  {
    method: 'patch',
    path: '/api/productcategories/:id',
    handler: patchProductCategory,
  },
  {
    method: 'delete',
    path: '/api/productcategories/:id',
    handler: deleteProductCategory,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
